import type { ComponentPropsWithRef } from 'react';
import styled from 'styled-components';

export interface SurfaceProps extends ComponentPropsWithRef<'div'> {}

export default styled('div')<SurfaceProps>`
  background-color: ${({ theme }) => theme.surface.backgroundColor};
  color: ${({ theme }) => theme.typography.body.bodyFontColor};
`;
